import { create } from 'zustand'
import { Project } from '../types'

type CurrentProject = {
  setCurrentProject: (project: Project | undefined) => void
  project: Project | undefined
}
export const useCurrentProject = create<CurrentProject>((set) => ({
  setCurrentProject: (project: Project | undefined) =>
    set({ project: project }),
  project: undefined,
}))
